import { Button } from "react-bootstrap";
import Styles from "./index.module.css";
import problemStore from "../../problemStore";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";

const Pagination = () => {
  const { params } = useRouteMatch();
  const { problemUrl } = params;
  const problemIndex = problemStore.findIndex((e) => e.url === problemUrl);

  return (
    <div className={Styles.pagination}>
      <div>
        {problemIndex !== 0 && (
          <Link to={`/problems/${problemStore[problemIndex - 1].url}`}>
            <Button className={Styles.btnLearnersbucket}>Prev</Button>
          </Link>
        )}
      </div>
      <div>
        <div>
          {problemIndex + 1} / {problemStore.length}
        </div>
      </div>
      <div>
        {problemIndex + 1 !== problemStore.length && (
          <Link to={`/problems/${problemStore[problemIndex + 1].url}`}>
            <Button className={Styles.btnLearnersbucket}>Next</Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Pagination;
